import { render, staticRenderFns } from "./BrokerPresentationDetailView.vue?vue&type=template&id=62f2cb02"
import script from "./BrokerPresentationDetailView.vue?vue&type=script&lang=js"
export * from "./BrokerPresentationDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports